import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LegalPagesService } from '../../services/legal-pages.service';

@Component({
  selector: 'app-delete-account',
  standalone: false,
  templateUrl: './delete-account.html',
  styleUrl: './delete-account.scss',
})
export class DeleteAccount implements OnInit, OnDestroy {
  private legalPagesService = inject(LegalPagesService);

  accountDeletionHtml = '';

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.legalPagesService
      .getLegalHtmlPage('account-deletion')
      .pipe(takeUntil(this.destroy$))
      .subscribe((text) => (this.accountDeletionHtml = text));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
